<template>
    <div class="light-tooltip-box">
        <div><slot/></div>
        <div class="light-tooltip">
            <span class="triangle"/>
            <InvoicePreview/>
        </div>
    </div>
</template>

<script>
    import InvoicePreview from "@/components/pages/registration/InvoicePreview";
    export default {
        name: "PriceTooltip",
        components: {InvoicePreview},
        props: {
            content: {}
        }
    }
</script>

<style lang="scss" scoped>
    /* Tooltip container */
    .light-tooltip {
        position: absolute;
        box-shadow: $box-shadow;
        background: #ffffff;
        padding: 10px 20px 10px 20px;
        border-radius: $card-border-radius;
        right: 0;
        margin-top: 5px;
        opacity: 0;
        visibility: hidden;
        transition: opacity .4s, visibility 0s ease .2s;
        width: $price-tooltip-width;
    }
    .light-tooltip-box {
        position: relative;
        z-index: 1000;
    }
    .triangle {
        box-shadow: $box-shadow;
        border-width: 0 6px 6px;
        border-style: solid;
        border-color: transparent;
        border-bottom-color: #ffffff;
        position: absolute;
        top: -6px;
        right: 7px;
        transform: translate-x(-50%);
    }
    .price-box:hover .light-tooltip{
        opacity: 1;
        visibility: visible;
        transition: opacity .4s, visibility 0s;
    }
</style>
